export interface AppVersionFile {
  /** Line 1 — latest git tag shown in the UI (e.g. sidebar). */
  displayVersion: string;
  /** Line 2 — unique build id (commit SHA); used to detect new deployments. */
  buildId: string;
}

export function parseAppVersionFile(raw: string): AppVersionFile | null {
  const lines = raw
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  if (lines.length >= 2) {
    return {
      displayVersion: lines[0],
      buildId: lines[1],
    };
  }

  if (lines.length === 1) {
    return {
      displayVersion: lines[0],
      buildId: lines[0],
    };
  }

  return null;
}
